export { createLottieAnimation } from '@sonyged/lottie-animation'
